
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseUrl = process.env.REACT_APP_BASE_URL;

export const supplierApi = createApi({
  reducerPath: 'supplierApi',
  baseQuery: fetchBaseQuery({
    baseUrl, // This should point to your backend URL
    credentials: 'include', // include credentials if needed
  }),
  endpoints: (builder) => ({
    createSupplier: builder.mutation({
      query: (body) => ({
        url: 'suppliers', // Your suppliers endpoint – adjust as needed
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useCreateSupplierMutation } = supplierApi;
